interface FilterOption {
  label: string;
  value: string;
}

interface CategoryFiltersProps {
  years: FilterOption[];
  regions: FilterOption[];
  sortOptions: FilterOption[];
  year: string;
  region: string;
  sort: string;
  onYearChange: (value: string) => void;
  onRegionChange: (value: string) => void;
  onSortChange: (value: string) => void;
  onReset: () => void;
}

function FilterRow({
  label,
  options,
  value,
  onChange,
}: {
  label: string;
  options: FilterOption[];
  value: string;
  onChange: (v: string) => void;
}) {
  return (
    <div className="flex flex-col gap-2 border-b border-background-200/50 py-3 last:border-b-0 sm:flex-row sm:items-center sm:gap-4">
      <span className="w-14 shrink-0 text-sm text-foreground-500">{label}</span>
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => (
          <button
            key={opt.value}
            type="button"
            onClick={() => onChange(opt.value)}
            className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
              value === opt.value
                ? "bg-primary-500 text-background-50"
                : "text-foreground-700 hover:bg-background-200/60 hover:text-foreground-950"
            }`}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default function CategoryFilters({
  years,
  regions,
  sortOptions,
  year,
  region,
  sort,
  onYearChange,
  onRegionChange,
  onSortChange,
  onReset,
}: CategoryFiltersProps) {
  return (
    <div className="rounded-lg border border-background-200/60 bg-background-100 px-4 py-2 md:px-5">
      <FilterRow label="年份" options={years} value={year} onChange={onYearChange} />
      <FilterRow label="地区" options={regions} value={region} onChange={onRegionChange} />
      <div className="flex flex-col gap-2 py-3 sm:flex-row sm:items-center sm:gap-4">
        <span className="w-14 shrink-0 text-sm text-foreground-500">排序</span>
        <div className="flex flex-wrap gap-2">
          {sortOptions.map((opt) => (
            <button
              key={opt.value}
              type="button"
              onClick={() => onSortChange(opt.value)}
              className={`flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
                sort === opt.value
                  ? "bg-accent-500 text-background-950"
                  : "text-foreground-700 hover:bg-background-200/60 hover:text-foreground-950"
              }`}
            >
              <i className="ri-sort-desc text-base"></i>
              {opt.label}
            </button>
          ))}
          <button
            type="button"
            onClick={onReset}
            className="flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-full border border-background-300/60 px-4 py-1.5 text-sm text-foreground-700 transition-colors hover:border-accent-500 hover:text-accent-500"
          >
            <i className="ri-refresh-line text-base"></i>
            重置筛选
          </button>
        </div>
      </div>
    </div>
  );
}